import axios from 'axios';
import { navigate } from 'gatsby';

const urlPrefix = process.env.API_URL ?? '';
// const urlPrefix =
//   process.env.NODE_ENV !== 'development' ? '/OneMedicalApi' : '';
const isDev = process.env.NODE_ENV === 'development';

const axiosInterceptorInstance = axios.create({
  baseURL: urlPrefix,
});

// eslint-disable-next-line complexity
const handleServerError = (response: any) => {
  if (
    response.config.url !==
      '/screening/?relativeUrl=MDMScreening/GetCustomerProfileFE' &&
    response.status >= 500
  ) {
    redirectToErrorPage();
  }
};

const redirectToErrorPage = () => {
  if (typeof window === 'undefined') {
    return;
  }

  const pathnames = window.location.pathname.split('/');
  // edp/life/product/entity {sit/uat/preprod}
  const product = pathnames[isDev ? 1 : 3];
  const entity = pathnames[isDev ? 2 : 4];
  navigate(`/${product}/${entity}/error`);
};
axiosInterceptorInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const response = error.response;
    if (response) {
      handleServerError(response);
    }
    return Promise.reject(error);
  },
);

export type JwtPayload = {
  payload: string;
};

async function fetchToken(payload: any | undefined) {
  try {
    const request: JwtPayload = {
      payload: payload === undefined ? '' : JSON.stringify(payload),
    };
    const response = await axios.post(
      urlPrefix + '/token/generate-payload',
      request,
    );
    const token = response.data;
    return token;
  } catch (error) {
    console.error('Error fetching token:', error);
  }
}

axiosInterceptorInstance.interceptors.request.use(
  async function (config) {
    try {
      const method = config.method?.toLowerCase();
      let refID: string | undefined;

      if (method === 'get') {
        const url = config.url?.toString() ?? '';
        refID = url?.split('/').pop();
      } else {
        refID = config.data?.refID || config.data;
      }
      const token = await fetchToken(refID);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`; // Attach the token to the request
      }
      return config;
    } catch (error) {
      return Promise.reject(error); // Handle errors in token fetching
    }
  },
  function (error) {
    return Promise.reject(error);
  },
);

export default axiosInterceptorInstance;
